import React from 'react';
import PrizesContainer from './PrizesContainer';
import Prize from './Prize';
import First from '../../resources/images/1.svg';
import Second from '../../resources/images/2.svg';
import Third from '../../resources/images/3.svg';

export default (props) => {
    return (
        <PrizesContainer title={props.lang.prize_label} title_2={props.lang.prize_label_2}>
            <Prize image={First} header={props.lang.first_place_header_label} subheader={props.lang.first_place_subheader_label} winner={props.lang.first_place_winner} number={props.lang.first_place_number} number_label={props.lang.first_place_number_label} place_label={props.lang.place_label} selectedLanguage={props.selectedLanguage} />
            <Prize image={Second} header={props.lang.second_place_header_label} subheader={props.lang.second_place_subheader_label} winner={props.lang.second_place_winner} number={props.lang.second_place_number} number_label={props.lang.second_place_number_label} place_label={props.lang.place_label} selectedLanguage={props.selectedLanguage} />
            <Prize image={Third} header={props.lang.third_place_header_label} subheader={props.lang.third_place_subheader_label} winner={props.lang.third_place_winner} number={props.lang.third_place_number} number_label={props.lang.third_place_number_label} place_label={props.lang.place_label} selectedLanguage={props.selectedLanguage} />
        </PrizesContainer>
    )
}


// WEBPACK FOOTER //
// ./src/components/prizes/index.jsx